export const REFERENCE_POINT = 'TIMEFRAME_REFERENCE_POINT';
export const POINT_1 = 'TIMEFRAME_POINT_1';
export const POINT_2 = 'TIMEFRAME_POINT_2';
export const POINT_3 = 'TIMEFRAME_POINT_3';

export default [POINT_1, POINT_2, POINT_3];
